import { SubListProps } from '../types'

import { List } from './List'

export const SubList = ({ data, depth, idx, onAddChild }: SubListProps) => {
  return (
    <>
      {data.map((list) => (
        <List
          idx={idx}
          key={list.name}
          data={list}
          depth={depth + 1}
          onAddChild={onAddChild}
        />
      ))}
    </>
  )
}
